import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as modalActions from '../actions/common/modalActions';

import {
    Modal,
    ModalHeader,
    ModalTitle,
    ModalClose,
    ModalBody,
    ModalFooter
} from 'react-modal-bootstrap';

class CustomModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {
            isOpen,
            handleHideModal,
            modalTitle,
            modalContent,
            closeText,
            confirmText,
            handleConfirm,
            confirmButton = <button type='button' onClick={handleConfirm} className='btn btn-primary modal-yes'>
                {confirmText}
            </button>,
        } = this.props;

        isOpen = isOpen || this.props.showModal;
        handleHideModal = handleHideModal || this.props.actions.hideModal;

        return <Modal isOpen={isOpen} onRequestHide={handleHideModal}>
            <ModalHeader>
                <ModalTitle>{modalTitle}</ModalTitle>
                <ModalClose onClick={handleHideModal}/>
            </ModalHeader>
            <ModalBody>
                {modalContent}
            </ModalBody>
            <ModalFooter>
                {confirmButton}
                <button type='button' className='btn btn-default clickable modal-no' onClick={handleHideModal}>
                    {closeText}
                </button>
            </ModalFooter>
        </Modal>
    }

}

function mapStateToProps(state, ownProps) {
    return {
        showModal: state.showModal,
    };
}

function mapDispatchToProps(dispatch) {


    return {
        actions: bindActionCreators(Object.assign(
            {},
            modalActions
        ), dispatch)
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(CustomModal);


// WEBPACK FOOTER //
// ./web/src/components/CustomModal.jsx